import axios from 'axios';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlimtalkApiV2 } from '../../../lib/api/alimtalk/AlimtalkApiV2';
import { putCsvToS3 } from '../../../lib/api/alimtalk/s3Upload';
import { ErrorResponseType } from '../../../lib/utils/checkErrorResponse';
import toastMsg from '../../../lib/toastMsg';
import { alimtalkToastMsg } from '../../../constants/service/toastMsg/alimtalkToastMsg';

export type UploadCsvVariables = {
  file: File;
  /** 유형 전환·재업로드 시 진행 중 업로드를 취소하기 위한 시그널 */
  signal?: AbortSignal;
};

/**
 * upload-url 발급 → S3 직접 PUT 오케스트레이션. 성공 시 csvS3Key 반환.
 * S3 PUT은 bare axios(인터셉터 없음)라 전역 에러 모달이 뜨지 않으므로 여기서 직접 토스트 처리한다.
 */
export const useUploadCsvMutation = (): UseMutationResult<string, ErrorResponseType, UploadCsvVariables> =>
  useMutation({
    mutationFn: async ({ file, signal }: UploadCsvVariables): Promise<string> => {
      // upload-url은 요청 body 없음 — 키는 서버가 uuid로 생성
      const { url, csvS3Key } = await AlimtalkApiV2.getUploadUrl();
      await putCsvToS3(url, file, signal);
      return csvS3Key;
    },
    onError: (error) => {
      // 취소는 사용자가 의도한 동작(유형 전환·재업로드)이므로 실패로 알리지 않는다
      if (axios.isCancel(error)) return;
      toastMsg.error(alimtalkToastMsg.UPLOAD_CSV_REQUEST_ERROR, error);
    },
  });
